import React from 'react';
import { TableRow, TableCell, IconButton, Tooltip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { formatValue } from '../../utils/utils';

const CategoryTableRow = ({ row, index, currency, handleExpandCategory, expandedCategory }) => {
  const isExpanded = expandedCategory?.category === row.category && expandedCategory?.currentYear === row.currentYear;
  const isEven = index % 2 === 0;
  const bgColor = isEven ? 'transparent' : 'action.hover';

  return (
    <TableRow
      sx={{
        backgroundColor: bgColor,
        transition: 'background-color 0.2s',
        '&:hover': {
          backgroundColor: 'action.selected',
        },
      }}
    >
      <TableCell
        align="center"
        sx={{
          position: 'sticky',
          left: 0,
          bgcolor: isEven ? 'background.paper' : 'action.hover',
          zIndex: 1,
          fontWeight: 500,
        }}
      >
        {row.category}
      </TableCell>
      <TableCell align="center">{row.currentYear}</TableCell>
      {row.monthlyValues.map((value, idx) => (
        <TableCell key={`${row.category}-current-${idx}`} align="center">
          {formatValue(value, currency)}
        </TableCell>
      ))}
      <TableCell align="center" sx={{ fontWeight: 700 }}>
        {formatValue(row.total, currency)}
      </TableCell>
      <TableCell align="center">
        <Tooltip title={isExpanded ? 'Fechar detalhes' : 'Ver detalhes'}>
          <IconButton
            onClick={() => handleExpandCategory(row)}
            size="small"
            sx={{
              bgcolor: isExpanded ? 'primary.main' : 'action.hover',
              color: isExpanded ? 'primary.contrastText' : 'inherit',
              '&:hover': {
                bgcolor: isExpanded ? 'primary.dark' : 'action.selected',
              },
            }}
          >
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default CategoryTableRow;
